export default __webpack_public_path__ + "static/B0083-9547e20caff109dff9c1c45a7e7a671b.png";